<template>
  <div>
    <div class='title'>
        <img src="../assets/img/home_03.png" >
    </div>
    <div class='banner_area'>
      <div class='banner_img'>
        <img src="../assets/img/bj_02.jpg" >
      </div>
        
        <div class='bn_left'>
            <img src="../assets/img/home_10.png" >
            <div>
              <a class='pc_hide' href="https://gyw.91360.com/">进入义诊平台 ></a>
              <a class='phone_hide' href="https://gy.91360.ai/">进入义诊平台 ></a>
            </div>
        </div>
        <div class='bn_right'>
            <div class='proposal_head'>
                <p>关于新型冠状病毒感染疫情防控期间病理医师</p>
                <p>开展义务远程病理会诊的倡议书</p>
            </div>
            <img class='bookhinge_left' src="../assets/img/home_07.png" >
            <img class='bookhinge_right' src="../assets/img/home_07.png" >
            <div class='proposal_body'>
              <div>
                <p>全国临床病理学专家和同仁：</p>
                <p>
                  2019年12月以来，湖北省武汉市等地陆续确诊了大量新型冠状病毒感染肺炎患者，
                  传染性强，给人民群众健康和生命、国家经济发展造成了重大损失。“生命重于泰山，
                  疫情就是命令，防控就是责任”。在党中央、国务院的正确领导和指挥下，
                  我国科学家和医务工作者在病原体鉴定、临床诊治和新药研发等防控方面都做出了卓有成效的工作。
                  然而，目前全国疫情形势仍然比较严峻，各地仍然处于严格的防控措施实施阶段，
                  交通限行等因素造成其他疾病患者就诊不便，湖北省及全国各地很多基层医院病理科医师资源不足，
                  许多疑难病例的病理诊断难以解决。为贯彻落实党中央和习近平主席关于“疫情防控要坚持全国一盘棋”的指示精神
                  ，本着为广大患者和基层病理工作者服务的精神，中国医师协会病理科医师分会和中华医学会病理学分会向全国临床病理医师发出倡议
                  ：在不影响本职工作的前提下，志愿在疫情防控期间力所能及地为基层医院，尤其是湖北省基层医院病理科，以远程病理会诊的形式，
                  开展疑难病例的义诊活动。
                </p>
                <p>
                  <span>1.</span>
                  倡议各位临床病理学专家和同仁（协会和学会委员为主）参加疑难病例远程病理义务会诊。
                  <span>该活动为公益性活动，自愿参加。</span>
                </p>
                <p>
                  <span>2.</span>
                  响应此倡议的志愿者请在2月10日晚12:00前通过微信或邮件向王哲教授（zhwang@fmmu.edu.cn）报名，
                  同时请将您的职称、单位、2寸正面照片和擅长专科病理领域一并提供。
                  <span>义诊活动拟持续2个月（将视疫情情况随时调整）。</span>
                </p>
                <p>
                  <span>3.</span>
                  此次倡议义诊活动拟利用91360平台。在该平台开辟义诊专栏，基层病理科扫描切片上传，相关专家进行会诊并提出诊断意见。
                  <span>此活动期间91360平台和志愿者不收取患者和病理科任何费用。</span>
                </p>
                <p>
                  感谢各位专家和同仁支持！愿大家平安、健康！让我们携起手来，早日战胜疫情！
                </p>
                <i>武汉加油！</i>
                <i>湖北加油！</i>
                <i>中国加油！</i>
                <div>
                  <p>中国医师协会病理科医师分会</p>
                  <p>中华医学会病理学分会</p>
                  <p>2020年2月7日</p>
                </div>
              </div> 
            </div>
        </div>  
    </div>
    <div class='specialist_apply'>
      <div class='mian'>
          <ul class='apply_btn clearfix'>
            <li>
              <a @click="goAnchor('#specialist')">
                <img src="../assets/img/home_18.png">
                <div class="t">
                    <p>义诊专家申请</p>
                </div>
                <div class="d">
                    <p>自愿参加疑难病例远程病理义务会诊的志愿者，能抽出时间义务远程病理会诊</p>
                </div>
              </a>
            </li>
            <li>
              <a @click="goAnchor('#hospital')">
                <img src="../assets/img/home_21.png">
                <div class="t">
                    <p>会诊医院申请</p>
                </div>
                <div class="d">
                    <p>需要加入远程义诊活动的医院方，需有数字切片扫描仪硬件，且可以访问互联网</p>
                </div>
              </a>
            </li>
            <!-- <li>
              <a @click="goAnchor('#hardware')">
                <img src="../assets/img/home_15.png">
                <div>
                    <p>硬件品牌支持</p>
                    <p>目前义诊平台兼容的数字切片扫描仪硬件品牌，其他不兼容的硬件品牌亦可申请加入</p>
                </div>
              </a>
            </li> -->
          </ul>
          <h1  id='specialist'>义诊专家申请流程</h1>
          <div class='specialist_process_desc'>
            <img src="../assets/img/lc_04.png">
            <div>
                <div>
                  <p>
                    1、<span>时间有限建议在线提交</span>
                    ，亦可通过微信或者邮件向王哲教授报名，
                    并提供如下信息(姓名、单位名称、手机号、电子邮箱、职称、擅长亚专科、2寸正面照片)，
                  </p>
                  <p>王哲教授邮箱：zhwang@fmmu.edu.cn</p>
                  <p>2、医学会根据情况汇总申请的相关信息，发给数字病理远程义诊公益平台方；</p>
                  <p>3、数字病理远程义诊公益平台会根据收到汇总信息，统一开通专家端会诊账号；</p>
                  <p>4、医生根据义诊平台提供的网址，输入账号密码后，即可诊断病例。</p>
                </div>
                <div @click='applyDialogVisible=true'>我要申请</div>
            </div>

          </div>
        <!-- <div class='hospital_apply'>
          
        </div>  -->
      </div>
    </div>
    <div class='hospital_apply'>
      <div class='mian'>
        <h1 id='hospital'>会诊医院申请流程</h1>
        <div class='hospital_process_desc'>
            <img src="../assets/img/lc_03.png">
            <div>
                <div>
                  <p>
                    1、<span>时间有限建议在线提交</span>
                    ，亦可通过微信或邮件向王哲教授报名，并提供如下信息（申请单位名称、联系人、手机号、电子邮箱、数字切片扫描仪品牌及型号）， 
                  </p>
                  <p>王哲教授邮箱：zhwang@fmmu.edu.cn</p>
                  <p>2、医学会根据情况汇总申请的相关信息，发给数字病理远程义诊公益平台方；</p>
                  <p>3、数字病理远程义诊公益平台会根据收到汇总信息，统一开通医院端申请账号；</p>
                  <p>4、院方根据义诊平台提供的网址，输入账号密码后，即可发起远程会诊。</p>
                </div>
                <div @click='hospitalDialogVisible=true'>
                  我要申请
                </div>
            </div>
          </div>
      </div>
    </div>
    <!-- <div class='hardware_brand'>
      <div class='mian'>
        <h1 id='hardware'>硬件品牌支持</h1>
        <p>目前义诊平台兼容滨松(日本)、3DHISTECH(匈牙利)、徕卡(德国)、罗氏(瑞士)、飞利浦(荷兰)、蔡司(德国)、宁波江丰、北京优纳、帝麦克斯、麦克奥迪、舜宇、智跃等主流厂商设备格式。</p>
        <p>(如有其他硬件品牌希望兼容，请联系<span>盖魏全</span>手机/微信号：17712857001)</p>
        <ul>
          <li>
            <img src="../assets/img/bn_03.png" >
          </li>
          <li>
            <img src="../assets/img/bn_05.png" >
          </li>
          <li>
            <img src="../assets/img/bn_07.png" >
          </li>
          <li>
            <img src="../assets/img/bn_09.png" >
          </li>
          <li>
            <img src="../assets/img/bn_15.png" >
          </li>
          <li>
            <img src="../assets/img/bn_17.png" >
          </li>
          <li>
            <img src="../assets/img/bn_19.png" >
          </li>
          <li>
            <img src="../assets/img/bn_21.png" >
          </li>
          <li>
            <img src="../assets/img/bn_27.png" >
          </li>
          <li>
            <img src="../assets/img/bn_28.png" >
          </li>
          <li>
            <img src="../assets/img/bn_29.png" >
          </li>
          <li>
            <img src="../assets/img/bn_30.png" >
          </li>
        </ul>
      </div>
    </div> -->
    <div class='footer'>
      <p>
        本站为
        <a class='pc_hide' :style="{color:'rgb(15,96,220)',textDecoration:'underline'}" href='https://gyw.91360.com' >数字病理远程义诊公益平台( gy.91360.com )</a> 
        <a class='phone_hide' :style="{color:'rgb(15,96,220)',textDecoration:'underline'}" href='https://gy.91360.ai/' >数字病理远程义诊公益平台( gy.91360.com )</a> 
        申请站，主办方：中国医师协会病理科医师分会、中华医学会病理学分会；技术支持91360。
      </p>
      <p>
        <a :style="{color:'rgb(15,96,220)',textDecoration:'underline'}" target="_blank" href='http://www.beian.miit.gov.cn/' >苏ICP备 13032250号</a> 
        <img src="../assets/img/icp.png"  style='vertical-align:bottom' >
        <a :style="{color:'rgb(15,96,220)',textDecoration:'underline'}" target="_blank" href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011402010258' >苏公网安备 32011402010112号</a>  
      </p>

    </div>
    

    <el-dialog class="pop" :close-on-click-modal="false" :visible.sync="applyDialogVisible" width="720px" top="3vh" :before-close="closeSpecialistPop">
        <slot slot="title">
          <div class='form_title'>
            病理医生远程义诊断公益活动义诊专家申请表
            <span>(需要包含以下信息)</span>
          </div>
        </slot>
        <el-form ref="form" :model="apllyForm" label-width="45%">
          <div class='form_content'>
            <el-form-item >
              <slot slot='label'>
                <div class='form_head_lable'>专家信息</div>
              </slot>
              <div class='form_head'>填写</div>
            </el-form-item>
            <el-form-item v-for='item in specialistApllyForm' :key='item.tag'  v-if='item.tag=="intro"' >
              <slot slot='label'>
                <div class='area_lable'>{{item.text}}</div>
              </slot>
              <el-input type="textarea" rows="3" class='spc_area' v-model="apllyForm[item.tag]"></el-input>
            </el-form-item>
            <el-form-item   v-else-if='item.tag=="show_avatar"' >
              <slot slot='label'>
                <div class='form_lable'>{{item.text}}</div>
              </slot>
              <div class='h_audio_box'>
                  <el-radio v-model="apllyForm.show_avatar" label="1">是</el-radio>
                  <el-radio v-model="apllyForm.show_avatar" label="0">否</el-radio>
              </div>
            </el-form-item>
            <el-form-item v-else-if='item.tag=="avatar"'>
                <slot slot='label'>
                  <div class='form_lable'>{{item.text}}<span>(2寸正面照片)</span></div>
                </slot>
                <div class='catch_avatar'>
                    <input type="file" accept="image/*"  @change="selectImgs" ref="file">
                    <div class='upload_btn'>选择照片</div>
                    <img v-show="sliceAvatar!=''" style="width:auto;height:36px;" :src="sliceAvatar" />
                    <!-- <div class='audio_box'>
                      <span>是否展示照片:</span>
                      <el-radio v-model="specialistAudio" label="1">是</el-radio>
                      <el-radio v-model="specialistAudio" label="0">否</el-radio>
                    </div> -->
                </div>
            </el-form-item>
            <el-form-item v-else>
              <slot slot='label'>
                <div class='form_lable'>{{item.text}}</div>
              </slot>
              <el-input class='spc_input' v-model="apllyForm[item.tag]" ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class='aplly_btn' @click='submit(0)'>提交</div>
    </el-dialog>

    <el-dialog class="pop" :close-on-click-modal="false" :visible.sync="hospitalDialogVisible" width="720px" :before-close="closeHospitalPop">
        <slot slot="title">
          <div class='form_title'>
            病理医生远程义诊公益活动会诊医院申请表
            <span>(需要包含以下信息)</span>
          </div>
        </slot>
        <el-form ref="form" :model="apllyForm" label-width="45%">
          <div class='form_content nobottom'>
            <el-form-item >
              <slot slot='label'>
                <div class='form_head_lable'>项目</div>
              </slot>
              <div class='form_head'>填写</div>
            </el-form-item>
            <el-form-item v-for='item in hospitalApllyForm' :key='item.tag'  v-if='item.tag=="has_internet"' >
              <slot slot='label'>
                <div class='form_lable'>{{item.text}}</div>
              </slot>
              <div class='h_audio_box'>
                <el-radio v-model="hospitalForm.has_internet" label="1">是</el-radio>
                <el-radio v-model="hospitalForm.has_internet" label="0">否</el-radio>
              </div>
            </el-form-item>
            <el-form-item v-else>
              <slot slot='label'>
                <div class='form_lable'>{{item.text}}</div>
              </slot>
              <el-input class='spc_input' v-model="hospitalForm[item.tag]" ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class='aplly_btn' @click='submit(!0)'>提交</div>
    </el-dialog>
    
    <!-- <span @click='open'>请求接口</span> -->

    <el-dialog  :visible.sync="dialogVisible" width="500px" :fullscreen='true' :lock-scroll='true' >
      <slot slot='title'>
        <div class='form_title'>截取照片</div>
      </slot>
      <div :style="{width:'100%',height:'400px'}">
        <vueCropper ref="cropper" 
            :img="option.img"
            :outputSize="option.size"
            :info="true"
            :outputType="option.outputType"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :fixedBox="option.fixedBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth" 
            :auto-crop-height="option.autoCropHeight"
            :fixedNumber="[1, 1]" ></vueCropper>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSlice">上 传</el-button>
        <el-button type="danger" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- <el-button type="primary" @click='dialogVisible=true'>主要按钮</el-button>
    <input type="file" accept="image/*"  @change="selectImgs" ref="file">
    <img :src="testimg" alt=""> -->
  
  </div>
</template>

<script>
import './index.css'
import { VueCropper } from "vue-cropper";
import {http} from "../http/axiosinstance"
import {Message} from 'element-ui'
export default {
  components: {
    VueCropper
  },
  data() {
    return {
      sliceAvatar:"",
      dialogVisible:false,//截图弹窗
      applyDialogVisible:false,
      hospitalDialogVisible:false,
      specialistAudio:'1',
      canContact:"1",//是否可连接互联网
      specialistApllyForm:[
        {tag:"name",text:"姓名"},
        {tag:"unit",text:"单位名称"},
        {tag:"phone",text:"手机号"},
        {tag:"email",text:"电子邮箱"},
        {tag:"title",text:"职称"},
        {tag:"skill",text:"擅长亚专科领域"},
        {tag:"city",text:"所在城市"},
        {tag:"avatar",text:"照片"},
        {tag:"show_avatar",text:"是否展示照片"},
        {tag:"intro",text:"个人简介"},
      ],
      hospitalApllyForm:[
        {tag:"name",text:"申请单位"},
        {tag:"scanner_brand",text:"数字扫描仪品牌"},
        {tag:"scanner_model",text:"数字扫描仪设备型号"},
        {tag:"has_internet",text:"是否可连接互联网"},
        {tag:"contact",text:"联系人"},
        {tag:"phone",text:"手机号"},
        {tag:"email",text:"电子邮箱"},
      ],
      option:{
        img: '',//裁切图片的地址
        outputSize: 1,//裁剪生成图片的质量 0.1-1
        full: true,//是否输出原图比例的截图
        outputType: 'png',//裁剪生成图片的格式
        canMove: true,//图片是否允许滚轮缩放
        fixedBox: true,//固定截图框大小 不允许改变
        original: true,//上传图片按照原始比例渲染
        canMoveBox: false,//截图框能否拖动
        canMove:true,// 上传图片是否可以移动
        autoCropWidth: '170',
        autoCropHeight: '230',
        autoCrop:true,//是否默认生成截图框
        // 开启宽度和高度比例
      },
      hospitalForm:{
        name:"",
        scanner_brand:"",
        scanner_model:"",
        has_internet:"1",
        contact:"",
        phone:"",
        email:"",
      },
      apllyForm:{
        name:"",
        unit:"",
        phone:"",
        email:"",
        title:"",
        skill:"",
        avatar:"",
        city:"",
        intro:"",
        show_avatar:"1",
        // profile:"",
      },
    };
  },
  
  methods:{
    closeSpecialistPop(){
      Object.keys(this.apllyForm).forEach(item=>{
          this.apllyForm[item] = '';
      })
      this.sliceAvatar = '';
      this.applyDialogVisible = false;
      
    },
    selectImgs(){
      let formData = new FormData();
      formData.append('img[]',this.$refs.file.files[0]);
      var src=window.URL.createObjectURL(this.$refs.file.files[0]);
      this.option.img = src;
      this.dialogVisible =true
    },
    closeHospitalPop(){
      this.hospitalDialogVisible = false;
      Object.keys(this.hospitalForm).forEach(item=>{
        if(item == 'has_internet'){
          this.hospitalForm[item] = '1'
        }else{
          this.hospitalForm[item] = '';
        }
      })
    },
    submit(a){
      const h = this.$createElement;
      // var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/ 

      // var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;//邮箱校验
      // var reg2 = /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;//手机校验
      if(a){
        // let fromKeys = Object.keys(this.hospitalForm)
        // for (var i = 0;i < fromKeys.length;i++){
        //     if(fromKeys[i]!='avatar'&&this.hospitalForm[fromKeys[i]].trim() =='' ){
        //       return Message({
        //         type:"warning",
        //         message:`${this.hospitalApllyForm.find(item=>item.tag == fromKeys[i]).text}不能为空`
        //       })
        //     }
        // }
        if(this.hospitalForm.name==''){
          return Message({
            type:"warning",
            message:"申请单位不能为空"
          })
        }
        // if(this.hospitalForm.email!==''&&(!reg.test(this.hospitalForm.email))){
        //   return Message({
        //     type:"warning",
        //     message:"请输入正确的邮箱格式"
        //   })
        // }
        if(this.hospitalForm.phone!==''&&this.hospitalForm.phone.trim().length != 11){
          return Message({
            type:"warning",
            message:"请输入正确的手机格式"
          })
        }
        http.post('/hospital',this.hospitalForm)
        .then(res=>{
          this.closeHospitalPop()
          this.$msgbox({
            message:h('p',null,[
            h('span',{style:'margin-top:20px;'},`${res.message} `),
            h('p',{style:'margin-top:10px;text-align:center'},'数字病理义诊公益平台:'),
            h('div',{style:'text-align:center'},[
              h('a',{class:'pc_hide', style:'color: rgb(15,96,220);font-size:18px;text-decoration:underline',domProps:{href:'https://gyw.91360.com/#/home'}},'gy.91360.com'),
              h('a',{class:'phone_hide', style:'color: rgb(15,96,220);font-size:18px;text-decoration:underline',domProps:{href:'https://gy.91360.ai/'}},'gy.91360.com'),
              ]
              ),  
            ]),
            confirmButtonText:'关闭',
            type: 'success',
          })
          // this.hospitalDialogVisible = false;
        })
      }else{
        // let fromKey = Object.keys(this.apllyForm)
        // for (var i = 0;i < fromKey.length;i++){
        //     if(fromKey[i]!='avatar'&&this.apllyForm[fromKey[i]].trim() =='' ){
        //       return Message({
        //         type:"warning",
        //         message:`${this.specialistApllyForm.find(item=>item.tag == fromKey[i]).text}不能为空`
        //       })
        //     }
        // }
        if(this.apllyForm.name==''){
          return Message({
            type:"warning",
            message:"姓名不能为空"
          })
        }
        // if(this.apllyForm.email!==''&&(!reg.test(this.apllyForm.email))){
        //   return Message({
        //     type:"warning",
        //     message:"请输入正确的邮箱格式"
        //   })
        // }
        if(this.apllyForm.phone!==''&&this.apllyForm.phone.trim().length != 11){
          return Message({
            type:"warning",
            message:"请输入正确的手机格式"
          })
        }
        // if(this.sliceAvatar == ''){
        //   return  Message({
        //     type:"warning",
        //     message:"请上传照片",
        //   })
        // }
        this.apllyForm.avatar = this.sliceAvatar;
        http.post('/doctor',this.apllyForm)
        .then(res=>{
          this.closeSpecialistPop()
          // this.sliceAvatar = '';
          this.$msgbox({
            message:h('p',null,[
            h('span',null,`${res.message} `),
            h('p',{style:'margin-top:10px;text-align:center'},'数字病理义诊公益平台:'),
            h('div',{style:'text-align:center'},[
              h('a',{class:'pc_hide', style:'color: rgb(15,96,220);font-size:18px;text-decoration:underline',domProps:{href:'https://gyw.91360.com/#/home'}},'gy.91360.com'),
              h('a',{class:'phone_hide',style:'color: rgb(15,96,220);font-size:18px;text-decoration:underline',domProps:{href:'https://gy.91360.ai/'}},'gy.91360.com'),
              ])
            ]),
            confirmButtonText:'关闭',
            type: 'success',
          })
          // this.applyDialogVisible = false;
        })
      }
    },
    handleClose(){
      this.dialogVisible = false;
    },
    confirmSlice(){
      this.$refs.cropper.getCropData((data) => {
          this.sliceAvatar = data;
          Message({
            type:"success",
            message:"上传成功",
          })
          this.dialogVisible = false;
      })
    },
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView()
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/index.vue